import React, {useEffect} from 'react';
import './App.css';
import Page from 'react-page-loading'
import Header from './Header1';
import Header2 from './Header2';
import Footer from './Footer'
import Home from './Home';
import {BrowserRouter as Router, Switch, Route } from "react-router-dom";
import Checkout from './Checkout';
import Lista from './Lista';
import Login from './Login';
import {auth} from "./firebase";
import {useStateValue} from "./StateProvider";
import Payment from './Payment';
import Orders from './Orders';
import {loadStripe} from "@stripe/stripe-js";
import {Elements} from "@stripe/react-stripe-js"


const promise = loadStripe(
  'pk_test_51HXdupEGMuFaaqux7wBQRQ1msr8kPxqEoD8mG5MQwu1K83FkTHavGdzUtKs2c1YDfA7N5P78XlmXAI4CYLEBgLph00FT0ceTRy'
);

function App() {
const [{}, dispatch]= useStateValue();


  useEffect(() => {
    auth.onAuthStateChanged((authUser) => {
      console.log('THE USER IS >>>', authUser);
      if(authUser){

        dispatch({
          type:'SET_USER',
          user: authUser
        })
      } else {

        dispatch({
          type:'SET_USER',
          user: null
        });
      }
    });
  }, []);

  return (
    <Router>
    <div className="App">
    <Page loader={"bubble"} color={"rgb(142, 165, 175)"} size={15} duration={4}>
      <Switch>
      <Route path="/orders">
      <Header2 />
          <Orders />
        </Route>
        <Route path="/login">
          <Login />
        </Route>
      <Route path="/checkout">
      <Header2 />
      <Checkout />
      </Route>
      <Route path="/payment">
      <Header2 />
    <Elements stripe={promise}>
      <Payment />
    </Elements>
      </Route>

      <Route path="/Lista">
      <Header2 />
      <Lista/>
      </Route>
        <Route path="/">
        <Header />
      <Home />
      </Route>
      </Switch>
      
      <Footer/>
      </Page>
    </div>
    </Router>
  );
}

export default App;
